export default "__VITE_ASSET__172fea22__"